module.exports = __webpack_public_path__ + "img/goal_other01.96472d7c.png";